import { useSuspenseQuery } from '@tanstack/react-query';
import type { GatheringSpotType } from '@outdoria/types';
import { fetcher } from '../utils';
import { GATHERING_SPOT_TYPES_ALL } from '../queryKeys';

export const useGetGatheringSpotTypesAll = () => {
  const queryFn = async (): Promise<GatheringSpotType[]> => {
    const res = await fetcher(`/v2/gathering_spot_types`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<
    GatheringSpotType[],
    unknown,
    GatheringSpotType[],
    string[]
  >({
    queryKey: GATHERING_SPOT_TYPES_ALL,
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
